import React from "react";
import { useLocation, useNavigate } from "react-router";
import ConfirmationModal from "../components/ConfirmationModal.jsx";
import { SECONDARY } from "../components/consolidation/Fields.jsx";
import { consolidationOrdersUrl, groupConsolidationOrders, saveOrdersReturn } from "../utils/consolidationOrderNavigation.js";

export default function useConsolidationOrderNavigation({ scope, allowed, pageContext }) {
  const navigate = useNavigate(), location = useLocation();
  const [selection, setSelection] = React.useState(null);
  const depart = (day, table) => {
    const token = crypto.randomUUID();
    const params = new URLSearchParams(location.search);
    params.set("consolidation_return", token);
    params.set("orderSearch", pageContext.ordersSearchQuery || "");
    params.set("orderScope", pageContext.orderScope || "dispatch");
    params.set("orderDate", pageContext.orderBrowseDateFilter || "");
    params.set("orderPending", pageContext.isPendingBillingApprovalFilter ? "1" : "0");
    params.set("orderCatalog", pageContext.requireFullOrdersCatalog ? "full" : "recent");
    saveOrdersReturn(scope, { token, url: `/data-manager?${params}`, page: pageContext, table });
    navigate(consolidationOrdersUrl(day.date, day.ids, token));
  };
  const open = (orders, table = {}) => {
    if (!allowed || !scope) return;
    const grouped = groupConsolidationOrders(orders);
    if (grouped.days.length === 1 && !grouped.missing.length) depart(grouped.days[0], table);
    else setSelection({ ...grouped, table });
  };
  const dialog = selection ? <ConfirmationModal title="Ouvrir dans Consolidation" eyebrow="Commandes"
    description="Choisissez la journée à vérifier. La validation portera sur le relevé complet de chaque tournée."
    cornerRadius="grain" contentDensity="compact" onCancel={() => setSelection(null)}
    confirmLabel="Fermer" onConfirm={() => setSelection(null)}>
    <div className="grid gap-2">
      {selection.days.map(day => <button type="button" key={day.date} className={SECONDARY}
        onClick={() => depart(day, selection.table)}>{day.date} · {day.ids.length} commande{day.ids.length > 1 ? "s" : ""}</button>)}
      {selection.missing.length ? <p role="status" className="text-xs text-amber-800">Sans date de livraison : {selection.missing.join(", ")}. Renseignez leur journée pour les retrouver dans Consolidation.</p> : null}
    </div>
  </ConfirmationModal> : null;
  return { open, dialog };
}
